// Centralizes browser-storage access so the storage backend (localStorage vs
// sessionStorage) for each key is defined in exactly ONE place. Reading/writing
// these keys directly from elsewhere is what previously caused a split-brain
// (writes to one backend, reads from the other).
//
// course -> sessionStorage: scoped per browser tab/window, so an admin can have
//   a different course open in each tab at the same time. (auth keys such as
//   refresh_token/role/user stay in localStorage so login is shared across tabs;
//   they can be migrated into this service later if desired.)

const COURSE_KEY = 'course';

const StorageService = {
    getCourse() {
        const raw = sessionStorage.getItem(COURSE_KEY);
        return raw ? JSON.parse(raw) : null;
    },
    setCourse(course) {
        if (course) {
            sessionStorage.setItem(COURSE_KEY, JSON.stringify(course));
        } else {
            sessionStorage.removeItem(COURSE_KEY);
        }
    },
};

export default StorageService;
